<template>
	<div class="footer-wrap">
		<div class="footer">
			<div class="footer-l">
				<div class="footer-phone">联系电话：{{detailModel.phone}}</div>
				<div class="copyright">版权所有： {{detailModel.copyRight}}</div>
				<div class="beian"><a target="_blank" href="https://beian.miit.gov.cn/">{{detailModel.filingOn}}</a></div>
				<div class="address" v-if="detailModel.address!=' '&&detailModel.address">联系地址：{{detailModel.address}}</div>
			</div>
			<div class="footer-r">
				<div class="img-list">
					<img :src="detailModel.appletCode" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'Footer',
		props: {
			
		},
		data(){
			return {
				detailModel: {}
			}
		},
		created(){
			this.getFooterData()
		},
		methods: {
			//获取底部数据
			async getFooterData(){
				let param = {}
				ajaxParam(param)
				const res = await post('website/index/getBottomConfig', qs.stringify(param))
				if(res.data.code==200){
					console.log(res.data)
					this.detailModel = res.data.entity
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.footer-wrap{
		background: #323f50;
		padding: 20px 0;
		color: #fff;
	}
	.footer{
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 980px;
		margin: 0 auto;
		box-sizing: border-box;
		font-size: 13px;
		.footer-l{
			line-height: 26px;
			a{
				color: #fff;
			}
			
		}
		.img-list{
			display: flex;
			flex-direction: column;
			justify-content: center;
			img{
				width: 90px;
				height: 90px;
			}
			span{
				display: block;
				margin-top: 20px;
			}
		}
		
	}
</style>
